import { render, staticRenderFns } from "./CreateImage.vue?vue&type=template&id=afd22d8e"
import script from "@/scripts/modal/rentalService/createImage.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/rentalService/createImage.js?vue&type=script&lang=js&external"
import style0 from "./CreateImage.vue?vue&type=style&index=0&id=afd22d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports